enum LoadingState {
  Initial,
  IsLoading,
  HasError,
  Done
}

export default LoadingState